<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M51 1214 c-21 -26 -21 -36 -21 -503 1 -406 3 -479 16 -496 18 -24
102 -33 317 -34 140 -1 147 0 147 19 0 19 -8 20 -222 22 l-223 3 0 360 0 360
495 0 495 0 3 -72 c2 -56 6 -73 17 -73 13 0 15 32 15 200 0 187 -1 201 -20
220 -19 19 -33 20 -509 20 l-490 0 -20 -26z m1003 -20 c3 -9 6 -60 6 -115 l0
-99 -500 0 -500 0 0 103 c0 67 4 107 12 115 9 9 132 12 494 12 430 0 483 -2
488 -16z"
      />
      <path
        d="M250 1095 c0 -12 17 -15 95 -15 78 0 95 3 95 15 0 12 -17 15 -95 15
-78 0 -95 -3 -95 -15z"
      />
      <path
        d="M620 1095 c0 -12 17 -15 90 -15 73 0 90 3 90 15 0 12 -17 15 -90 15
-73 0 -90 -3 -90 -15z"
      />
      <path
        d="M430 780 c0 -29 4 -40 15 -40 11 0 15 11 15 40 0 29 -4 40 -15 40
-11 0 -15 -11 -15 -40z"
      />
      <path
        d="M837 739 c-115 -18 -218 -97 -271 -209 -27 -57 -31 -75 -31 -150 1
-73 5 -94 30 -145 37 -76 110 -149 183 -182 47 -22 72 -27 142 -27 110 0 186
31 260 110 77 82 95 128 95 249 0 109 -12 145 -78 229 -72 91 -212 144 -330
125z m211 -64 c60 -33 111 -84 144 -147 19 -36 23 -58 23 -143 0 -84 -4 -107
-23 -147 -32 -65 -94 -125 -160 -156 -76 -35 -202 -38 -274 -5 -66 30 -133 96
-165 162 -23 47 -27 69 -27 141 -1 105 28 176 100 244 69 66 128 87 239 83 77
-2 98 -7 143 -32z"
      />
      <path
        d="M860 470 l0 -120 120 0 c100 0 120 3 120 15 0 12 -18 15 -105 15
l-105 0 0 105 c0 87 -3 105 -15 105 -12 0 -15 -20 -15 -120z"
      />
      <path
        d="M707 283 c-16 -16 -4 -23 38 -23 25 0 45 -2 45 -4 0 -2 -11 -24 -25
-47 -28 -50 -33 -89 -10 -89 10 0 17 14 21 41 4 22 17 56 31 75 13 20 21 40
18 45 -7 10 -108 13 -118 2z"
      />
      <path
        d="M857 272 c-10 -10 -17 -24 -17 -30 0 -17 27 -15 34 3 7 20 42 19 50
-1 9 -23 -8 -46 -53 -74 -60 -36 -54 -50 24 -50 37 0 65 4 65 10 0 6 -19 10
-42 11 l-43 0 25 17 c64 44 79 88 38 116 -30 21 -61 20 -81 -2z"
      />
      <path
        d="M977 283 c-4 -3 -7 -42 -7 -85 0 -63 3 -78 15 -78 10 0 15 10 15 34
0 47 9 66 31 66 16 0 19 -8 19 -50 0 -38 4 -50 15 -50 13 0 15 11 13 56 -3 66
-23 88 -58 66 -18 -11 -20 -10 -20 18 0 29 -9 38 -23 23z"
      />
      <path
        d="M162 648 c4 -59 28 -63 28 -4 0 35 -4 46 -16 46 -12 0 -14 -9 -12
-42z"
      />
      <path
        d="M300 645 c0 -33 4 -45 15 -45 11 0 15 12 15 45 0 33 -4 45 -15 45
-11 0 -15 -12 -15 -45z"
      />
      <path
        d="M430 645 c0 -33 4 -45 15 -45 11 0 15 12 15 45 0 33 -4 45 -15 45
-11 0 -15 -12 -15 -45z"
      />
      <path
        d="M167 553 c-4 -3 -7 -24 -7 -45 0 -27 4 -38 15 -38 11 0 15 12 15 45
0 42 -7 54 -23 38z"
      />
      <path
        d="M300 515 c0 -33 4 -45 15 -45 11 0 15 12 15 45 0 33 -4 45 -15 45
-11 0 -15 -12 -15 -45z"
      />
      <path
        d="M430 515 c0 -33 4 -45 15 -45 11 0 15 12 15 45 0 33 -4 45 -15 45
-11 0 -15 -12 -15 -45z"
      />
      <path
        d="M160 380 c0 -29 4 -40 15 -40 11 0 15 11 15 40 0 29 -4 40 -15 40
-11 0 -15 -11 -15 -40z"
      />
      <path
        d="M300 380 c0 -29 4 -40 15 -40 11 0 15 11 15 40 0 29 -4 40 -15 40
-11 0 -15 -11 -15 -40z"
      />
      <path
        d="M430 380 c0 -29 4 -40 15 -40 11 0 15 11 15 40 0 29 -4 40 -15 40
-11 0 -15 -11 -15 -40z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconAgendamento72h',
}
</script>

<style></style>
